import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-sgzp-app2login',
  templateUrl: './sgzp-app2-login.component.html',
  styleUrls: ['./sgzp-app2-login.component.css'],
})
export class SgzpApp2LoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
